const system = require("@/libs/system");
const wxminiprogram = require('./platform/wxminiprogram');
const ikeaapp = require("./platform/ikeaapp")
const web = require("./platform/web")
const util = require("@/libs/utils")

var isFastClick = false;
module.exports = {
  open(page, params) {
    console.log(`isFastClick: ${isFastClick}, page: ${page}`);
    // 防止短时间内多次点击打开链接
    if (isFastClick) return;
    isFastClick = true;
    setTimeout(function () {
      isFastClick = false;
    }, 1000);
    this._currentPlatform().open(page, params)
  },
  _currentPlatform() {
    /**
     * 兼容WEB的路由跳转逻辑
     */
    const platform = util.getClientPlatform()
    if (platform === 'PcWeb' || platform === 'MobileWeb') {
      return web
    } else if (system.currentSystem() === 'miniprogram') {
      return wxminiprogram
    } else {
      return ikeaapp
    }
  }
}



// WEBPACK FOOTER //
// ./src/libs/router/index.js